import React, { useEffect, useState, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import ResumeButton from "../../Buttons/ResumeButton/ResumeButton";

import "./AddAdditionalFieldModal.scss";

function AdditionalResume(props) {
  const [selectedValue, setSelectedValue] = useState("");

  const handleSelect = (e) => {
    setSelectedValue(e.target.value);
  };
  const optionValues = [
    {
      name: "Google",
      value: "custom_google",
    },
    {
      name: "Linkedin",
      value: "custom_linkedin",
    },
    {
      name: "Facebook",
      value: "custom_facebook",
    },
    {
      name: "Yahoo",
      value: "custom_yahoo",
    },
    {
      name: "Github",
      value: "custom_github",
    },
    {
      name: "Instagram",
      value: "custom_instagram",
    },
    {
      name: "Twitter",
      value: "custom_twitter",
    },
    {
      name: "Skype",
      value: "custom_skype",
    },
    {
      name: "Signal",
      value: "custom_signal",
    },
    {
      name: "Whatsapp",
      value: "custom_whatsapp",
    },
    {
      name: "Add Custom Field",
      value: "custom",
    },
  ];

  return (
    <>
      <Modal
        className="additional-field-modal "
        show={props.show}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Button
            type="button"
            className="close"
            onClick={() => {
              props.handleAddAdditionalField();
            }}
            style={{ zIndex: "1", top: "13px" }}
          >
            <span aria-hidden="true">
              <img
                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                alt="closeicon"
                className="add_close"
              />
            </span>
            <span className="sr-only">Close</span>
          </Button>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Additional Fields
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-3">
          <div className="container">
            <div className="d-flex">
              <div className="col-md-8 add_select_div">
                {props && props.show && (
                  <select
                    name="level"
                    style={{ height: "50px", borderRadius: "6px" }}
                    className="form-control customform level mt-1"
                    onChange={handleSelect}
                    value={selectedValue}
                  >
                    <option value=""> Choose custom field</option>
                    {optionValues &&
                      optionValues.map((data) => {
                        let data1 = Object.keys(
                          props &&
                            props.resumeFields &&
                            props.resumeFields.data[0]
                        ).findIndex((x) => x == data.value);
                        if (data1 != -1) {
                          return;
                        } else {
                          return (
                            <>
                              <option value={data.value}>{data.name}</option>
                            </>
                          );
                        }
                      })}
                  </select>
                )}
              </div>
              <div className="col-md-4 mt-2">
                <ResumeButton
                  padding="10px 20px"
                  success
                  alt="plus"
                  title="Add"
                  className="mr-2 add-field-button"
                  onClick={() => {
                    if (selectedValue != "") {
                      props.addResumeField(
                        props.sectionRef,
                        selectedValue,
                        props.sectionId
                      );
                    }
                    props.handleAddAdditionalField();
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default AdditionalResume;
